import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnChanges, OnDestroy {
  @Input() blob: Blob | null = null;
  objectUrl: string | null = null;
  // Rotación en grados (0/90/180/270). Solo herramienta de giro; se reinicia al cambiar de imagen.
  rotation = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blob']) {
      this.revoke();
      this.rotation = 0;
      if (this.blob) {
        this.objectUrl = URL.createObjectURL(this.blob);
      }
    }
  }

  /** Gira la imagen 90° en sentido horario. */
  rotate(): void {
    this.rotation = (this.rotation + 90) % 360;
  }

  ngOnDestroy(): void {
    this.revoke();
  }

  private revoke(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }
}
